<template>
  <v-card-actions class="pa-0">
    <v-spacer></v-spacer>
    <cambiar-estado-cuota v-if="item.canCorregir" @changeStatus="changeStatus"
      :estados="item.estados">
      <v-btn color="darkgrey" flat icon class="button-element">
        <v-icon>rule</v-icon>
      </v-btn>
    </cambiar-estado-cuota>
      <v-btn icon flat small @click="goCuota" class="pa-0 ma-0 mt-1">
        <v-tooltip bottom>
            <v-badge dot overlap left color="red" slot="activator">
              <span slot="badge" v-if="item.tieneNotificaciones || item.requiereCorreccion">!</span>
              <v-icon v-if="item.canEdit" color="blue">edit</v-icon>
              <v-icon v-else color="blue">visibility</v-icon>
            </v-badge>
          <span v-if="item.requiereCorreccion">Requiere corrección</span>
          <span v-else-if="item.tieneNotificaciones">Observaciones nuevas</span>
          <span v-else>Ver cuota</span>
        </v-tooltip>
      </v-btn>
  </v-card-actions>
</template>

<script>
import CambiarEstadoCuota from './CambiarEstadoCuota'

export default {
  components: {
    CambiarEstadoCuota
  },

  props: {
    item: Object
  },

  methods: {
    goCuota () {
      this.$parent.$parent.$parent.$emit('goCuota', this.item.pk)
    },
    changeStatus (estado) {
      this.$parent.$parent.$parent.$emit('changeStatus', this.item.pk, estado)
    }
  }
}
</script>
